<template>
  <div>
    <v-row>
      <v-col cols="12">
        <runtime-categories-config />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <runtime-extremum-config />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RuntimeCategoriesConfig from '../../../../components/configs/runtimeCategoriesConfig'
import RuntimeExtremumConfig from '../../../../components/runtime-extremum-config/index';
export default {
  components: {
    RuntimeCategoriesConfig,
    RuntimeExtremumConfig
  }
}
</script>